import useGameStore from "../store/GameStore";

export function getPlayerById(playerId) {
  const riders = useGameStore.getState().riders;

  const id = parseInt(playerId);
  return riders?.find((player) => player.id === id);
}
